import { render, staticRenderFns } from "./editluarprovinsi.vue?vue&type=template&id=67b424c2&"
import script from "./editluarprovinsi.vue?vue&type=script&lang=js&"
export * from "./editluarprovinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports